import {WBIcon} from '@wandb/ui';
import {WBButton} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon, IconName} from '@wandb/weave/components/Icon';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

type EmptyStateProps = {
  iconName: IconName;
  header: string;
  body?: string;
  buttonText?: string;
  onClickButton?: () => void;
  withExtraPadding?: boolean;
};

export const EmptyState: React.FC<EmptyStateProps> = React.memo(
  ({iconName, header, body, buttonText, onClickButton, withExtraPadding}) => {
    return (
      <Container withExtraPadding={withExtraPadding}>
        <EmptyStateIconContainer>
          <Icon name={iconName} color={globals.SIENNA_550} />
        </EmptyStateIconContainer>
        <EmptyStateHeader>{header}</EmptyStateHeader>
        {body && <EmptyStateBody>{body}</EmptyStateBody>}
        {buttonText && (
          <EmptyStateButton onClick={onClickButton}>
            <EmptyStateButtonIcon /> {buttonText}
          </EmptyStateButton>
        )}
      </Container>
    );
  }
);

export const Container = styled.div<{withExtraPadding?: boolean}>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: ${globals.WHITE};
  position: relative;
  margin-bottom: 40px;
  border: 1px solid ${globals.MOON_200};
  border-radius: 8px;
  padding: 32px;
`;

const EmptyStateIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: rgba(255, 201, 51, 0.2);
`;

const EmptyStateIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const EmptyStateHeader = styled.div`
  font-size: calc(${globals.fontSizeStandard} * 1.5);
  margin-top: calc(${globals.spu} * 2);
`;

const EmptyStateBody = styled.div`
  color: ${globals.textSecondary};
  font-size: calc(${globals.fontSizeStandard} * 1.125);
  margin-top: calc(${globals.spu} * 0.75);
  max-width: 720px;
`;

const EmptyStateButton = styled(WBButton)`
  &&&&& {
    padding: calc(${globals.spu} * 1.25) calc(${globals.spu} * 2);
    margin-top: calc(${globals.spu} * 2);
  }
`;

const EmptyStateButtonIcon = styled(WBIcon).attrs({name: `plus`})`
  &&&&& {
    font-size: calc(${globals.fontSizeStandard} * 1.125);
    font-weight: 600;
    margin-right: ${globals.spu};
  }
`;
